<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "app",
  
})
</script>
<template>
	<el-config-provider :size="getGlobalComponentSize" :locale="getGlobalI18n">
		<Setings ref="setingsRef" v-show="setLockScreen" />
		<router-view />
	</el-config-provider>
</template>

<script setup lang="ts" name="app">
import { defineAsyncComponent, computed, ref, onBeforeMount, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useTagsViewRoutes } from '@/stores/tagsViewRoutes';
import { useThemeConfig } from '@/stores/themeConfig';
import { store, getRouteInfo } from '@/store/store';
import other from '@/utils/other';
import { Local, Session } from '@/utils/storage';
import mittBus from '@/utils/mitt';
import setIntroduction from '@/utils/setIconfont';
import { StartStomp, StopStomp } from '@/utils/stomp';

// import { Star } from '@element-plus/icons-vue/dist/types';

// 引入组件
const LockScreen = defineAsyncComponent(() => import('@/layout/lockScreen/index.vue'));
const Setings = defineAsyncComponent(() => import('@/layout/navBars/topBar/setings.vue'));
const CloseFull = defineAsyncComponent(() => import('@/layout/navBars/topBar/closeFull.vue'));
// const Upgrade = defineAsyncComponent(() => import('@/layout/upgrade/index.vue'));
// const Sponsors = defineAsyncComponent(() => import('@/layout/sponsors/index.vue'));

// 定义变量内容
const { messages, locale } = useI18n();
const setingsRef = ref();
const route = useRoute();
const stores = useTagsViewRoutes();
const storesThemeConfig = useThemeConfig();
const { themeConfig } = storeToRefs(storesThemeConfig);

// 设置锁屏时组件显示隐藏
const setLockScreen = computed(() => {
	// 防止锁屏后，刷新出现不相关界面
	// https://gitee.com/lyt-top/vue-next-admin/issues/I6AF8P
	return themeConfig.value.isLockScreen ? themeConfig.value.lockScreenTime > 1 : themeConfig.value.lockScreenTime >= 0;
});
// 获取版本号
// const getVersion = computed(() => {
// 	let isVersion = false;
// 	if (route.path !== '/login') {
// 		// @ts-ignore
// 		if ((Local.get('version') && Local.get('version') !== __NEXT_VERSION__) || !Local.get('version')) isVersion = true;
// 	}
// 	return isVersion;
// });
// 获取全局组件大小
const getGlobalComponentSize = computed(() => {
	return other.globalComponentSize();
});
// 获取全局 i18n
const getGlobalI18n = computed(() => {
	return messages.value[locale.value];
});
// 设置初始化，防止刷新时恢复默认
onBeforeMount(() => {
	// 设置批量第三方 icon 图标
	setIntroduction.cssCdn();
	// 设置批量第三方 js
	setIntroduction.jsCdn();
});
// 页面加载时
onMounted(() => {
	document.title = store.state.config.title || '';
	var cjson = sessionStorage.getItem('dc-cfg');
	if (cjson) {
		store.state.cfg = JSON.parse(cjson);
	}
	cjson = sessionStorage.getItem('dc-user');
	if (cjson) {
		store.state.user = JSON.parse(cjson);
	}
	cjson = sessionStorage.getItem('dc-menu');
	if (cjson) {
		store.state.app.bmenuloaded = false;
		store.state.app.menudata = JSON.parse(cjson);
	}
	// cjson = sessionStorage.getItem('dc-msn-' + store.state.user.iduser);
	// if (cjson) {
	// 	store.state.msn = JSON.parse(cjson);
	// }
	window.addEventListener('beforeunload', () => {
		//sessionStorage.setItem('dc-msn-' + store.state.user.iduser, JSON.stringify(store.state.msn));
		if (store.state.app.stomp && store.state.app.stomp.connected) {
			if (store.state.app.listenerSubs && store.state.app.listenerSubs.size > 0) {
				for (const [key, value] of store.state.app.listenerSubs) {
					store.state.app.stomp.unsubscribe(value);
				}
			}
			store.state.app.stomp.deactivate();
			store.state.app.stomp = null;
			store.state.app.listenerSubs = new Map();
		}
	});
	//启动消息机制

	// 监听布局配置弹窗点击打开
	mittBus.on('openSetingsDrawer', () => {
		setingsRef.value.openDrawer();
	});
	// 获取缓存中的布局配置
	if (Local.get('themeConfig')) {
		let tcf = Local.get('themeConfig');
		tcf.isshowMSN = false;
		storesThemeConfig.setThemeConfig({ themeConfig: tcf });
		document.documentElement.style.cssText = Local.get('themeConfigStyle');
	}
	// 获取缓存中的全屏配置
	if (Session.get('isTagsViewCurrenFull')) {
		stores.setCurrenFullscreen(Session.get('isTagsViewCurrenFull'));
	}
});
// 页面销毁时，关闭监听布局配置/i18n监听
onUnmounted(() => {
	mittBus.off('openSetingsDrawer', () => {});
	if (store.state.app.stomp && store.state.app.stomp.connected) {
		if (store.state.app.listenerSubs && store.state.app.listenerSubs.size > 0) {
			for (const [key, value] of store.state.app.listenerSubs) {
				store.state.app.stomp.unsubscribe(value);
			}
		}
		store.state.app.stomp.deactivate();
		store.state.app.stomp = null;
		store.state.app.listenerSubs = new Map();
	}
});
</script>
